import type { User } from '@esf/shared';

export const demoUsers: User[] = [
  // --- ORG-001: Bristol City Council (primary demo org) ---
  {
    email: 'admin@ubloquity.io',
    organisationId: 'ORG-001',
    role: 'SuperAdmin',
    name: 'Platform Admin',
    enabled: true,
    lastLoginAt: '2026-04-01T08:15:00.000Z',
    createdAt: '2024-01-15T09:00:00.000Z',
    updatedAt: '2026-04-01T08:15:00.000Z',
  },
  {
    email: 'j.smith@bristol.gov.uk',
    organisationId: 'ORG-001',
    role: 'OrgAdmin',
    name: 'James Smith',
    phoneNumber: '+44 7700 900123',
    enabled: true,
    lastLoginAt: '2026-04-01T09:30:00.000Z',
    createdAt: '2024-01-20T10:00:00.000Z',
    updatedAt: '2026-03-28T16:00:00.000Z',
    invitedBy: 'admin@ubloquity.io',
    invitedAt: '2024-01-18T14:00:00.000Z',
  },
  {
    email: 's.patel@bristol.gov.uk',
    organisationId: 'ORG-001',
    role: 'AssetManager',
    name: 'Sunita Patel',
    phoneNumber: '+44 7700 900456',
    enabled: true,
    lastLoginAt: '2026-03-31T14:20:00.000Z',
    createdAt: '2024-02-05T11:00:00.000Z',
    updatedAt: '2026-03-31T14:20:00.000Z',
    invitedBy: 'j.smith@bristol.gov.uk',
    invitedAt: '2024-02-03T09:00:00.000Z',
  },
  {
    email: 'm.jones@bristol.gov.uk',
    organisationId: 'ORG-001',
    role: 'AssetManager',
    name: 'Mark Jones',
    phoneNumber: '+44 7700 900789',
    enabled: true,
    lastLoginAt: '2026-03-29T11:45:00.000Z',
    createdAt: '2024-02-10T09:30:00.000Z',
    updatedAt: '2026-03-29T11:45:00.000Z',
    invitedBy: 'j.smith@bristol.gov.uk',
    invitedAt: '2024-02-08T15:00:00.000Z',
  },
  {
    email: 'd.williams@bristol.gov.uk',
    organisationId: 'ORG-001',
    role: 'FieldTech',
    name: 'David Williams',
    phoneNumber: '+44 7700 901234',
    enabled: true,
    lastLoginAt: '2026-04-01T07:00:00.000Z',
    createdAt: '2024-03-01T08:00:00.000Z',
    updatedAt: '2026-04-01T07:00:00.000Z',
    invitedBy: 'j.smith@bristol.gov.uk',
    invitedAt: '2024-02-28T10:00:00.000Z',
  },
  {
    email: 'r.taylor@bristol.gov.uk',
    organisationId: 'ORG-001',
    role: 'FieldTech',
    name: 'Rachel Taylor',
    phoneNumber: '+44 7700 901567',
    enabled: true,
    lastLoginAt: '2026-03-31T07:30:00.000Z',
    createdAt: '2024-03-15T08:30:00.000Z',
    updatedAt: '2026-03-31T07:30:00.000Z',
    invitedBy: 'j.smith@bristol.gov.uk',
    invitedAt: '2024-03-13T11:00:00.000Z',
  },
  {
    email: 'e.chen@bristol.gov.uk',
    organisationId: 'ORG-001',
    role: 'Analyst',
    name: 'Emily Chen',
    enabled: true,
    lastLoginAt: '2026-03-28T10:00:00.000Z',
    createdAt: '2024-04-01T09:00:00.000Z',
    updatedAt: '2026-03-28T10:00:00.000Z',
    invitedBy: 'j.smith@bristol.gov.uk',
    invitedAt: '2024-03-29T14:00:00.000Z',
  },
  {
    email: 'public@bristol.gov.uk',
    organisationId: 'ORG-001',
    role: 'PublicViewer',
    name: 'Public Access',
    enabled: true,
    createdAt: '2024-04-15T12:00:00.000Z',
    updatedAt: '2024-04-15T12:00:00.000Z',
  },

  // --- ORG-002: Bath & North East Somerset Council ---
  {
    email: 'a.brown@bathnes.gov.uk',
    organisationId: 'ORG-002',
    role: 'OrgAdmin',
    name: 'Andrew Brown',
    phoneNumber: '+44 7700 902345',
    enabled: true,
    lastLoginAt: '2026-03-30T09:00:00.000Z',
    createdAt: '2024-03-12T10:00:00.000Z',
    updatedAt: '2026-03-30T09:00:00.000Z',
    invitedBy: 'admin@ubloquity.io',
    invitedAt: '2024-03-10T16:00:00.000Z',
  },
  {
    email: 'k.wilson@bathnes.gov.uk',
    organisationId: 'ORG-002',
    role: 'FieldTech',
    name: 'Karen Wilson',
    phoneNumber: '+44 7700 902678',
    enabled: true,
    lastLoginAt: '2026-03-29T08:00:00.000Z',
    createdAt: '2024-04-05T09:30:00.000Z',
    updatedAt: '2026-03-29T08:00:00.000Z',
    invitedBy: 'a.brown@bathnes.gov.uk',
    invitedAt: '2024-04-03T11:00:00.000Z',
  },

  // --- ORG-003: South Gloucestershire Council ---
  {
    email: 'p.davies@southglos.gov.uk',
    organisationId: 'ORG-003',
    role: 'OrgAdmin',
    name: 'Peter Davies',
    phoneNumber: '+44 7700 903456',
    enabled: true,
    lastLoginAt: '2026-03-27T10:30:00.000Z',
    createdAt: '2024-06-05T09:00:00.000Z',
    updatedAt: '2026-03-27T10:30:00.000Z',
    invitedBy: 'admin@ubloquity.io',
    invitedAt: '2024-06-01T14:00:00.000Z',
  },
  {
    email: 'l.hughes@southglos.gov.uk',
    organisationId: 'ORG-003',
    role: 'AssetManager',
    name: 'Laura Hughes',
    enabled: true,
    lastLoginAt: '2026-03-25T15:00:00.000Z',
    createdAt: '2024-07-01T08:00:00.000Z',
    updatedAt: '2026-03-25T15:00:00.000Z',
    invitedBy: 'p.davies@southglos.gov.uk',
    invitedAt: '2024-06-28T10:00:00.000Z',
  },
];
